import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-check-with-background.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const CheckWithBackgroundIcon = createSvgIcon(<Icon />, 'CheckWithBackgroundIcon');
